require('./bootstrap');

import Vue from 'vue';
import { InertiaApp } from "@inertiajs/inertia-vue";
Vue.use(InertiaApp);

// Get round a frustrating Webpack bug with code splitting
import '../css/blank.css';

// Ziggy named routes
import route from '../../vendor/tightenco/ziggy/dist/js/route';
import { Ziggy } from './routes.js';
Vue.prototype.$route = (name, params, absolute) => route(name, params, absolute, Ziggy).url();

// Fonts
require('typeface-open-sans');
require('typeface-roboto');

// Start the Vue app
// Using Inertia here to simulate a single page app.
const app = document.getElementById('app');

new Vue({
    render: h => h(InertiaApp, {
        props: {
            initialPage: JSON.parse(app.dataset.page),
            resolveComponent: (name) => import(`./Pages/${name}`).then(module => module.default),
        },
    }),
}).$mount(app);
